<template>
  <div class="vote-notice">
    <window-box>
      <p class="notes">
        <span v-html="$t('text001', { samelist_url: `/${$route.params.lang}/character` })" /><br><br>
        <span v-html="$t('text002')" />
      </p>
    </window-box>
  </div>
</template>
<script>
import WindowBox from '@components/global/window-box.vue'
import localeAbout from '@locales/top'

export default {
  name: 'voteNotice',
  $messages: localeAbout,
  components: {
    WindowBox,
  },
}
</script>
<style lang="scss" scoped>
.vote-notice {
  margin-top: 20px;
  padding: 0 5px;
  .notes {
    white-space: pre-wrap;
  }
}
</style>
